import React, { useState, useEffect } from 'react'
import SearchBox from '../../components/reusableComponents/SearchBox';
import SwitcherBtn from '../../components/reusableComponents/SwitcherBtn';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLoginUser, setLoader, setSnackBar, setSnackBarMessage, setSnackBarVariant } from '../../redux';
import { formSnackbar } from '../../_services/_constants/snackbar.constant';
import { useMediaQuery } from '@mui/material';
import StudioTable from './studioTable';
import StudioCard from './studioCard';
import { default_limit } from '../../_services/_constants/recordLimitset.constant';
import ApiService from '../../_services/ApiService';

function StudioList(props) {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userData.userData);
  const smScreen = useMediaQuery('(max-width:768px)')
  //to get the search input value
  const [searchInput, setSearchInput] = useState(null)
  const [layoutComponent, setLayoutComponent] = useState(true)
  const [studioList, setStudioList] = useState([])
  const [renderComponent, setRenderComponent] = useState()
  /* const [open, setOpen] = useState(false) */
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(default_limit);

  useEffect(function () {
    if (userData.id) {
      dispatch(fetchLoginUser(userData.id));
      getData(userData.id, page);
    }
  }, [userData.id, rowsPerPage, page]);


  function getData(userId, page, isTableLayout = layoutComponent) {
    const offset = page;
    const limit = rowsPerPage;
    const endpoint = isTableLayout ? 'studioTableList' : 'studioList';
    dispatch(setLoader(true))
    ApiService.get(endpoint, { limit, offset }).then(response => {
      dispatch(setLoader(false))
      if (response.status === 200) {
        setStudioList([])
        setStudioList(response.data)
        setPage(page);
        setRenderComponent(null)
        copyHandleLayoutRerender(isTableLayout, response.data, page)
      }
      else {
        dispatch(setSnackBar(true));
        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => dispatch(setSnackBar(false)), 3000)
      }
    }).catch(function (error) {
      dispatch(setLoader(false))
      dispatch(setSnackBar(true));
      dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
      dispatch(setSnackBarVariant('error'));
      setTimeout(() => dispatch(setSnackBar(false)), 3000)
      return error.response;
    })
  }
  useEffect(() => {
    if (!layoutComponent) {
      setRenderComponent(<StudioTable studioListData={studioList}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
      />)
      setLayoutComponent(true)
    }
  }, [smScreen])

  //to get the searchbox input and filter the data
  //to hit the search and display the result
  const getSearchArtistData = (value, userId, page, isTableLayout = layoutComponent) => {
    const offset = page;
    const limit = rowsPerPage;
    const endpoint = isTableLayout ? 'studioTableList' : 'searchStudio';
    const params = { search: value, limit, offset };
    dispatch(setLoader(true))
    ApiService.get(endpoint, params).then(function (response) {
      dispatch(setLoader(false))
      if (response.status === 200) {
        setStudioList([])
        setStudioList(response.data)
        setPage(page);
        setRenderComponent(null)
        copyHandleLayoutRerender(isTableLayout, response.data, page)
      }
      else {
        dispatch(setSnackBar(true));
        dispatch(setSnackBarMessage(formSnackbar.errors.imgUploadSize));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => dispatch(setSnackBar(false)), 3000)
      }
    }).catch(function (error) {
      dispatch(setLoader(false))
      dispatch(setSnackBar(true));
      dispatch(setSnackBarMessage(formSnackbar.errors.imgUploadSize));
      dispatch(setSnackBarVariant('error'));
      setTimeout(() => dispatch(setSnackBar(false)), 3000)
      return error.response;
    })
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchInput = (value) => {
    if (value) {
      setSearchInput(value)
    } else {
      getData(userData.id, page)
    }
  }
  useEffect(
    function () {
      if (searchInput) {
        let delaySearch;
        delaySearch = setTimeout(() => {
          getSearchArtistData(searchInput, userData.id, 0)
        }, 1000);
        return () => clearTimeout(delaySearch);
      } else {
      }
    }, [searchInput])
  //get sets the list data

  //to set the current display component card or table view
  const handleLayoutComponent = (currentComp) => {
    setLayoutComponent(currentComp)
    setRenderComponent(null)
    getData(userData.id, page, currentComp)
  }

  //to render the component on search
  const copyHandleLayoutRerender = (currentComp, artistData, activePage = page) => {
    setLayoutComponent(currentComp)
    currentComp ? setRenderComponent(<StudioTable studioListData={artistData}
      page={activePage}
      setPage={setPage}
      setRowsPerPage={setRowsPerPage}
      rowsPerPage={rowsPerPage}
    />) : setRenderComponent(<StudioCard studioListData={artistData}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      page={activePage}
      rowsPerPage={rowsPerPage}
    />)

  }

  return (
    <div className={`row ${smScreen ? 'p-2' : ''}`} style={{ padding: '1rem 1rem 3rem 1rem' }}>
      <h2 style={{ marginLeft: '10px' }}>Studio List</h2>
      <div className={`d-flex gap-2 justify-content-between mt-2`}>
        <div className='flex-grow-1' style={{ maxWidth: '18rem', marginLeft: '10px' }}>
          <SearchBox placeholder="Search" handleSearchInput={handleSearchInput} />
        </div>

        <div className='switchView'>
          <SwitcherBtn layoutComponent={layoutComponent} handleLayoutComponent={handleLayoutComponent} />
        </div>
        {/* </div> */}
      </div>
      <div>
        {renderComponent}
      </div>
    </div>
  )
}

export default StudioList
